var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('proxy-model',{ref:"proxy-model"}),_c('set-user-model',{ref:"set-user"}),_c('safe-route',{ref:"safe-route"}),_c('hot-wallet',{ref:"hot-wallet"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }